/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from 'react';
import { singleTest } from '../../data/providers/testsProvider';
import { ITest } from '../../data/types';

/**
 * Hook to subscribe to a single test by ID
 * @param testId The ID of the test to subscribe to
 * @returns The test data and loading state
 */
export function useTest(initialTest: ITest): {
  test: ITest | null;
  loading: boolean;
} {
  const [test, setTest] = React.useState<ITest>(initialTest);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect((): (() => void) => {
    setLoading(true);

    const subscription = singleTest(initialTest.id, false, false).subscribe({
      next: (testData: ITest): void => {
        setTest(testData);
        setLoading(false);
      },
      error: (_: Error): void => {
        setLoading(false);
      },
    });

    return (): void => subscription.unsubscribe();
  }, [JSON.stringify(initialTest)]);

  return { test, loading };
}

export default useTest;
